<!--<div class="card">
    <header>
        <h3 class="mb-0">Performance</h3>
    </header>
    <main class="card-body">-->
<!--<button (click)="toggleDisplayValue()">Toggle</button>-->
<ng-container *ngIf="ui.viewportSize$ | async as viewportSize">
    <div class="row gx-2 gy-3 justify-content-between align-items-center mb-3">
        <div class="col-3 col-md-auto" *ngIf="showPeriodSelector">
            <mat-form-field
                appearance="fill"
                *ngIf="viewportSize === 'xs' || viewportSize === 'sm'"
            >
                <mat-label>Range</mat-label>
                <mat-select
                    (selectionChange)="setPeriod($event.value)"
                    [value]="(period$ | async).name"
                    [compareWith]="isSelected"
                >
                    <mat-option *ngFor="let option of periods" [value]="option">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="group" *ngIf="viewportSize !== 'xs' && viewportSize !== 'sm'">
                <button
                    *ngFor="let option of periods"
                    class="btn btn-sm secondary"
                    role="option"
                    [class.active]="(period$ | async).name === option.name"
                    [attr.aria-selected]="(period$ | async).name === option.name || null"
                    (click)="setPeriod(option)"
                >
                    <tabler-icon
                        name="calendar"
                        *ngIf="option.name === 'Custom'"
                        style="height: 16px; width: 16px"
                        class="my-n2 me-1"
                    ></tabler-icon>
                    <span [class.visually-hidden]="option.name === 'Custom'">
                        {{ option.name }}
                    </span>
                </button>
            </div>
        </div>
        <div class="col-3 col-md-auto" *ngIf="showScaleSelector">
            <mat-form-field
                appearance="fill"
                *ngIf="viewportSize === 'xs' || viewportSize === 'sm'"
            >
                <mat-label>Scale</mat-label>
                <mat-select
                    (selectionChange)="setScale($event.value)"
                    [value]="scale$ | async"
                >
                    <mat-option *ngFor="let option of scale" [value]="option.value">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="group" *ngIf="viewportSize !== 'xs' && viewportSize !== 'sm'">
                <button
                    *ngFor="let option of scale"
                    class="btn btn-sm secondary"
                    role="option"
                    [class.active]="(scale$ | async) === option.value"
                    [attr.aria-selected]="(scale$ | async) === option.value || null"
                    (click)="setScale(option.value)"
                >
                    {{ option.name }}
                </button>
            </div>
        </div>
        <div
            class="col-6 col-md col-xl-auto order-md-4 mt-md-1 text-right"
            *ngIf="showBenchmarkSelector"
        >
            <mat-form-field
                [appearance]="
                    viewportSize === 'xs' || viewportSize === 'sm' ? 'fill' : 'standard'
                "
                class="sb-benchmark-field mt-xl-1"
            >
                <mat-label>Benchmarks</mat-label>
                <mat-select [formControl]="benchmark" multiple>
                    <mat-select-trigger>
                        {{benchmark.value?.[0] || ''}}
                        <span *ngIf="(benchmark.value?.length || 0) > 1">
                            (+{{ (benchmark.value?.length || 0) - 1 }}
                            {{ benchmark.value?.length === 2 ? 'other' : 'others' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option
                        *ngFor="let benchmarkOption of benchmarkOptions$ | async"
                        [value]="benchmarkOption.id"
                    >
                        {{ benchmarkOption.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <ng-container *ngIf="period$ | async as period">
            <div
                class="col-12 col-md-8 mt-2 order-md-3 order-xl-4"
                *ngIf="(period$ | async).name === 'Custom'"
            >
                <form
                    class="row gx-2 mt-sm-n2 mb-n3 mb-sm-n4"
                    [formGroup]="reactiveForm"
                    autocomplete="off"
                >
                    <div class="col-6 col-sm-3 col-md-auto">
                        <mat-form-field appearance="fill" class="sb-datepicker-field">
                            <mat-label>From</mat-label>
                            <input
                                matInput
                                [matDatepicker]="fromDateRef"
                                formControlName="fromDate"
                                [max]="getMaxFromDate()"
                            />
                            <mat-datepicker-toggle matSuffix [for]="fromDateRef">
                                <i-tabler
                                    matDatepickerToggleIcon
                                    name="calendar"
                                    style="height: 32px; width: 20px"
                                ></i-tabler>
                            </mat-datepicker-toggle>
                            <mat-datepicker #fromDateRef></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-6 col-sm-3 col-md-auto">
                        <mat-form-field appearance="fill" class="sb-datepicker-field">
                            <mat-label>To</mat-label>
                            <input
                                matInput
                                [matDatepicker]="toDateRef"
                                formControlName="toDate"
                                [min]="fromDateRef.value"
                                [max]="today"
                            />
                            <mat-datepicker-toggle matSuffix [for]="toDateRef">
                                <i-tabler
                                    matDatepickerToggleIcon
                                    name="calendar"
                                    style="height: 32px; width: 20px"
                                ></i-tabler>
                            </mat-datepicker-toggle>
                            <mat-datepicker #toDateRef></mat-datepicker>
                            <mat-error
                                *ngIf="reactiveForm.getError('invalidDate', 'toDate')"
                            >
                                To date have to be greater than from date
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </ng-container>
        <div class="col-12 order-last px-0 sb-chart-content">
            <!-- TODO: replace with new pro tip component once merged -->
            <div
                role="alert"
                class="info mx-auto"
                style="width: fit-content; max-width: 640px"
                *ngIf="
                    showDateNotice && (period$ | async).name === 'Custom' && !showError
                "
                @fadeInOut
            >
                <header>
                    <h3 class="h4 mb-1">Showing performance since inception</h3>
                    <button
                        class="close"
                        type="button"
                        (click)="showDateNotice = false"
                    ></button>
                </header>
                Chart shows performance since first known transaction
                {{ minDate$ | async | date : 'shortDate' }}.
            </div>
            <div
                role="alert"
                class="warning mx-auto"
                style="width: fit-content; max-width: 640px"
                *ngIf="showMaxDateNotice && !showError"
                @fadeInOut
            >
                <header>
                    <h3 class="h4 mb-1">Incomplete data</h3>
                    <button
                        class="close"
                        type="button"
                        (click)="showMaxDateNotice = false"
                    ></button>
                </header>
                Please note that the chart only shows data until
                {{ maxDate$ | async | date : 'shortDate' }} which is the most recent data
                point we have at the moment. Please contact client services at
                <a href="mailto:clientservice@swimbird.se">clientservice@swimbird.se</a>
                for more information and help if you believe this is an error.
            </div>
            <div
                role="alert"
                class="mx-auto sb-chart-error-alert"
                style="width: fit-content; max-width: 640px"
                @fadeInOut
                [class.warning]="error.type === 'warning'"
                [class.critical]="error.type === 'critical'"
                *ngIf="showError && error.title"
            >
                <header>
                    <h3 class="h4 mb-1">{{ error.title }}</h3>
                    <button
                        class="close"
                        type="button"
                        (click)="showError = false"
                    ></button>
                </header>
                <p [innerHTML]="error.content"></p>
            </div>
            <app-bb-chart
                *ngIf="!showError"
                [options]="(chartConfig$ | async)?.options"
                [data]="(chartConfig$ | async)?.data"
                [loading]="loading"
                (loadingChange)="onLoadingStateChange($event)"
                (chartRef)="chartRef = $event"
                [fitHeightToParent]="fitHeightToParent"
            >
                <div class="skeleton-loader-gradient">
                    <div
                        class="skeleton-loader skeleton-loader-chart-area"
                        aria-busy="true"
                    ></div>
                </div>
            </app-bb-chart>
        </div>
    </div>
</ng-container>

<!--</main>
</div>-->
